
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {api} from "@/Api";

    @Component({})
    export default class Login extends Vue{
        public email: string = '';
        public password: string = '';

        public getAccessToken(){
            if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email))
            {
                this.$store.commit('throwError', 'Cette adresse email est incorrecte');
                return;
            }
            if(!this.password.length){
                this.$store.commit('throwError', 'Merci de saisir un mot de passe');
                return;
            }
            this.$store.commit('loading');
            api.login(this.email, this.password);
        }

    }
